import {StrategyManager} from 'components/StrategyManager';

import {withProviders} from './providers';

export const App = withProviders(StrategyManager);
